var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.7,
    height: 19.25,
    viewBox: "0 0 32.7 19.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-594.331 -394.739)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M626.369,400.743h-3.428a.663.663,0,0,0-.468.194l-5.948,5.948a.667.667,0,0,0-.194.468.657.657,0,0,0,.194.468l3.428,3.428a.655.655,0,0,0,.468.193.667.667,0,0,0,.469-.193l5.947-5.948a.657.657,0,0,0,.194-.468v-3.427A.663.663,0,0,0,626.369,400.743Zm-.663,1.325v2.492l-5.285,5.284-2.49-2.491,5.285-5.285Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.769,
    cy: 0.769,
    r: 0.769,
    transform: "translate(623.231 403.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M616.331,402.989a2.753,2.753,0,0,0-2.062-2.66v-4.081a1.478,1.478,0,0,0-.687-1.342,1.5,1.5,0,0,0-1.522.092l-5.537,3.178h-7.379a4.813,4.813,0,1,0,0,9.625h.687v4.125h0a2.063,2.063,0,1,0,4.125,0h0V407.8h2.567l5.531,3.175a1.757,1.757,0,0,0,.887.262,1.284,1.284,0,0,0,.641-.166,1.48,1.48,0,0,0,.687-1.343v-4.081A2.752,2.752,0,0,0,616.331,402.989Zm-20.625,0a3.442,3.442,0,0,1,3.438-3.438h3.437v6.875h-3.437A3.441,3.441,0,0,1,595.706,402.989Zm6.188,9.625a.689.689,0,0,1-.688-.688h0V407.8h1.375v4.125h0A.688.688,0,0,1,601.894,412.614Zm11-2.885a.7.7,0,0,1-.011.123.654.654,0,0,1-.138-.065l-5.7-3.27a.386.386,0,0,0-.036-.016.663.663,0,0,0-.066-.03c-.022-.008-.044-.015-.067-.021s-.039-.01-.059-.013a.569.569,0,0,0-.081-.008c-.012,0-.022,0-.034,0h-2.75v-6.875h2.75c.012,0,.023,0,.035,0a.731.731,0,0,0,.079-.008.411.411,0,0,0,.061-.014.555.555,0,0,0,.066-.02.67.67,0,0,0,.066-.03c.012-.006.024-.009.036-.016l5.7-3.274a.672.672,0,0,1,.132-.061.724.724,0,0,1,.011.124Zm1.375-5.557V401.8a1.363,1.363,0,0,1,0,2.367Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.14ad5c5aa860c61087096806dca45357.svg";
export { ForwardRef as ReactComponent };